/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_AllInputs */

const en_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Services`)
};

const ar_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الخدمات`)
};

const bn_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব সার্ভিস`)
};

const de_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Dienste`)
};

const es_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los servicios`)
};

const fr_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les services`)
};

const pt_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os serviços`)
};

const zh_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有服务`)
};

const tr_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Hizmetler`)
};

const ru_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все услуги`)
};

const pl_svc_all = /** @type {(inputs: Svc_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie usługi`)
};

/**
* | output |
* | --- |
* | "All Services" |
*
* @param {Svc_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_all = /** @type {((inputs?: Svc_AllInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_AllInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_all(inputs)
	if (locale === "bn") return bn_svc_all(inputs)
	if (locale === "de") return de_svc_all(inputs)
	if (locale === "es") return es_svc_all(inputs)
	if (locale === "fr") return fr_svc_all(inputs)
	if (locale === "pt") return pt_svc_all(inputs)
	if (locale === "zh") return zh_svc_all(inputs)
	if (locale === "tr") return tr_svc_all(inputs)
	if (locale === "ru") return ru_svc_all(inputs)
	if (locale === "pl") return pl_svc_all(inputs)
	return en_svc_all(inputs)
});